var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('h1',{class:{
      'text-h1': _vm.$mq === 'xl' || _vm.$mq === 'l',
      'text-h2T': _vm.$mq === 'm',
      'text-h4': _vm.$mq === 's'
    }},[_vm._v("\n    Новости нашей компании\n  ")]),_c('div',{staticClass:"news-list"},_vm._l((_vm.news),function(item,index){return _c('NewsSection',{key:index,attrs:{"ind":index,"date":item.date,"header":item.header,"desc":item.desc,"img":item.img}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }